import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormAction } from '../../enums';
import { FormInput } from '../../models';

@Component({
  selector: 'app-map-form-base',
  template: ''
})
export class MapFormBaseComponent {

  //Todo, aqui hay que homogenizar la entrada
  //@Input() formInput: FormInput<any> = null;
  @Input() formInput: any = null;

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<any>();

  @Output() closeEvent = new EventEmitter<any>();

  isUpdate = false;

  form = this.fb.group({});

  constructor(protected fb: FormBuilder) {
  }

  initAdd() { }
  initUpdate() { }
  setFormLogic() { }

}
